// extracted by mini-css-extract-plugin
module.exports = {"strike":"Strike__strike___1XV1b","strikeContent":"Strike__strikeContent___10gLb"};


// WEBPACK FOOTER //
// webpack://aws_amplify_ui/src/Strike.css?fcd8